import { SanitizedHtmlViewer } from "@/components/popups/email-health-test-results";
import StyledTooltip from "@/components/styled-tooltip";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useGetTestResult } from "@/hooks/use-inboxplacement";
import { Info } from "lucide-react";
import { usePlacementContext } from "./placement-context";

const PlacementTestDetails = () => {
  const { state } = usePlacementContext();

  const { data, isLoading } = useGetTestResult(
    state.params.email,
    state.params.type,
    state.params.testId
  );
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <h2 className="text-lg font-medium">Test Email Details</h2>
        <StyledTooltip description="Shows the details of the test email that was sent. This helps identify if the email was delivered to the inbox or spam folder.">
          <Info className="h-4 w-4 text-muted-foreground" />
        </StyledTooltip>
      </div>
      <Card>
        <CardContent className="p-4">
          {isLoading ? (
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <Skeleton className="h-5 w-12" />
                <Skeleton className="h-5 w-64" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="h-5 w-16" />
                <Skeleton className="h-5 w-80" />
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <Skeleton className="h-5 w-24" />
                  <div className="flex gap-2">
                    <Skeleton className="h-7 w-20" />
                    <Skeleton className="h-7 w-20" />
                  </div>
                </div>
                <Skeleton className="h-64 w-full" />
              </div>
            </div>
          ) : (
            <div className="space-y-4 text-sm">
              <div className="flex items-center gap-2">
                <span className="font-semibold">From:</span>
                <span className="text-muted-foreground">
                  {data?.test?.senderEmail || "Not available"}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-semibold">Subject:</span>
                <span className="text-muted-foreground">
                  {data?.test?.subject || "Not available"}
                </span>
              </div>
              <SanitizedHtmlViewer
                html={data?.test?.htmlBody || ""}
                isPrinting={state.isPrinting}
                labelText="Email Body"
              />
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PlacementTestDetails;
